import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { fEth } from '../../features/my-collection/Unbind/utils'
import {
  selectAzukiBalance,
  selectL1NativeTokenBalance,
  selectL2NativeTokenBalance,
  selectWeb3BalancesLoaded,
} from '../../store/web3/signer'
import Icon from '../../images/link-out-bridge.svg'

export const BalancesHeader: React.FC = () => {
  const { t } = useTranslation()
  const balancesLoaded = useSelector(selectWeb3BalancesLoaded)
  const [oppositeL2NativeTokenBalance, l2NativeTokenBalances] = useSelector(
    selectL2NativeTokenBalance,
  )
  const [l1NativeTokenBalance, oppositeL1NativeTokenBalance] = useSelector(
    selectL1NativeTokenBalance,
  )
  const [l1AzukiBalance, l2AzukiBalance] = useSelector(selectAzukiBalance)
  const [isL2, setIsL2] = useState(true)
  const balances = (
    <>
      <StyledBalance>
        MATIC{' '}
        {balancesLoaded
          ? fEth(
              (isL2 ? l2NativeTokenBalances : oppositeL2NativeTokenBalance)
                ?.balance,
              4,
            )
          : '-'}
      </StyledBalance>
      <StyledBalance>
        {isL2 ? 'WETH' : 'ETH'}{' '}
        {balancesLoaded
          ? fEth(
              (isL2 ? oppositeL1NativeTokenBalance : l1NativeTokenBalance)
                ?.balance,
              4,
            )
          : '-'}
      </StyledBalance>
      <StyledBalance>
        AZUKI{' '}
        {balancesLoaded
          ? fEth((isL2 ? l2AzukiBalance : l1AzukiBalance)?.balance, 4)
          : '-'}
      </StyledBalance>
    </>
  )
  return (
    <StyledBalancesHeaderContainer>
      <StyledLayerContainer>
        <StyledLayerButton
          isActive={isL2}
          disabled={!balancesLoaded}
          onClick={() => {
            setIsL2(false)
          }}
        >
          {t('l1Bal')}
        </StyledLayerButton>
        <StyledLayerButton
          disabled={!balancesLoaded}
          isActive={!isL2}
          onClick={() => {
            setIsL2(true)
          }}
        >
          {t('l2Bal')}
        </StyledLayerButton>
        <Spacer />
        <StyledMaticBridgeLink
          href="https://wallet.matic.network/bridge/"
          target="_blank"
          rel="noreferrer"
        >
          <StyledIcon src={Icon} />
          {t('maticTokenBridge')}
        </StyledMaticBridgeLink>
      </StyledLayerContainer>

      <StyledBalancesContainer>{balances}</StyledBalancesContainer>
    </StyledBalancesHeaderContainer>
  )
}

const StyledIcon = styled.img`
  width: 1rem;
  height: 1rem;
  margin-right: 0.5rem;

  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
`

const Spacer = styled.div`
  flex-grow: 0.5;
`

const StyledMaticBridgeLink = styled.a`
  font-size: small;
  color: white;
  text-align: end;
  padding: 1rem;
  padding-bottom: 0.5rem;
  padding-top: 0rem;
  display: flex;

  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
`

const StyledLayerButton = styled.button<{ isActive: boolean }>`
  flex-grow: 1;
  ${(props) => (props.isActive || props.disabled ? 'opacity: 50%;' : '')}
  color:  ${(props) =>
    props.isActive || props.disabled ? 'white' : '#00FFC2'};
  padding: 1rem;
  padding-bottom: 0.5rem;
  padding-top: 0rem;
`
const StyledLayerContainer = styled.section`
  display: flex;
`

const StyledBalance = styled.h3`
  color: white;

  font-size: 1rem;
  font-weight: 400;
`

const StyledBalancesContainer = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  /* border: 2px solid #00ffc2; */
  padding: 1rem;
  justify-items: center;
`

const StyledBalancesHeaderContainer = styled.section`
  flex-direction: column;
  justify-content: space-evenly;
  display: flex;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(13px);
  -webkit-backdrop-filter: blur(13px);
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  padding: 1rem;
  padding-top: 1rem;
  padding-bottom: 0rem;
`
